document.addEventListener('DOMContentLoaded', () => {
    const hero = document.querySelector('[data-almc-hero-motion]');
    const homeFooter = document.getElementById('footer');
    const accessDrawer = document.getElementById('almcGuestAccessDrawer');
    const footerSheet = document.getElementById('almcHomeFooterSheet');
    const homeSearchForm = document.querySelector('[data-almc-home-search]');
    const homeSearchInput = homeSearchForm?.querySelector('[data-almc-home-search-input]');
    const homeSearchSurface = document.querySelector('[data-almc-home-search-surface]');
    const homeSearchResults = homeSearchSurface?.querySelector('[data-almc-home-search-results]');
    const homeSearchStatus = homeSearchSurface?.querySelector('[data-almc-home-search-status]');
    const homeSearchIntro = homeSearchSurface?.querySelector('[data-almc-home-search-intro]');
    const homeSearchAllResults = homeSearchSurface?.querySelector('[data-almc-home-search-all-results]');
    let closeHomeSearch = () => {};

    // El layout público de Porto crea varios contextos de apilado (sidebar,
    // header y body). Dejamos el panel como hijo directo de body para que su
    // overlay cubra la app completa, incluido el lateral derecho.
    if (accessDrawer && accessDrawer.parentElement !== document.body) {
        document.body.append(accessDrawer);
    }

    if (footerSheet && footerSheet.parentElement !== document.body) {
        document.body.append(footerSheet);
    }

    if (homeSearchSurface && homeSearchSurface.parentElement !== document.body) {
        document.body.append(homeSearchSurface);
    }

    const accessDrawerPanel = accessDrawer?.querySelector('.almc-home-access-drawer-panel');
    const accessDrawerTriggers = [...document.querySelectorAll('[data-almc-access-drawer-trigger]')];
    const accessDrawerCloseButtons = accessDrawer
        ? [...accessDrawer.querySelectorAll('[data-almc-access-drawer-close]')]
        : [];
    const accessTabs = accessDrawer
        ? [...accessDrawer.querySelectorAll('[data-almc-access-tab]')]
        : [];
    const accessPanels = accessDrawer
        ? [...accessDrawer.querySelectorAll('[data-almc-access-panel]')]
        : [];
    const footerSheetPanel = footerSheet?.querySelector('.almc-home-footer-sheet-panel');
    const footerSheetContent = footerSheet?.querySelector('[data-almc-footer-sheet-content]');
    const footerSheetTitle = footerSheet?.querySelector('[data-almc-footer-sheet-title]');
    const footerSheetCloseButtons = footerSheet
        ? [...footerSheet.querySelectorAll('[data-almc-footer-sheet-close]')]
        : [];
    const productLoadMore = document.getElementById('almc-product-load-more');
    const goalSection = document.getElementById('objetivos');
    const goalTabs = [...document.querySelectorAll('[data-almc-goal-tab]')];
    const goalPanels = [...document.querySelectorAll('[data-almc-goal-panel]')];
    const leadDialog = document.getElementById('almcHomeLeadDialog');
    const leadForm = document.querySelector('[data-almc-lead-form]');
    const leadGoalLabel = leadDialog?.querySelector('[data-almc-lead-goal-label]');
    const leadObjectiveInput = document.querySelector('[data-almc-lead-objective]');
    const leadStatus = document.querySelector('[data-almc-lead-status]');
    const leadSubmit = document.querySelector('[data-almc-lead-submit]');
    const leadSuccess = document.querySelector('[data-almc-lead-success]');
    const leadIntro = document.querySelector('[data-almc-lead-intro]');
    const leadSubmitLabel = leadSubmit?.querySelector('span');
    const leadSubmitDefaultLabel = leadSubmitLabel?.textContent || '';

    const footerRevealMedia = window.matchMedia('(min-width: 1200px)');
    const footerSheetMedia = window.matchMedia('(max-width: 991.98px)');
    const goalAutoplayMotionMedia = window.matchMedia('(prefers-reduced-motion: no-preference)');
    const footerRevealCssVariable = '--almc-home-footer-reveal-height';
    const minimumFooterRevealHeight = 520;
    let footerRevealHeight = 0;
    let footerRevealFrame = null;
    let lastAccessDrawerTrigger = null;
    let accessDrawerCloseTimer = null;
    let lastFooterSheetTrigger = null;
    let footerSheetCloseTimer = null;

    const syncFooterRevealHeight = () => {
        footerRevealFrame = null;

        if (!homeFooter?.classList.contains('almc-home-footer')) {
            return;
        }

        if (!footerRevealMedia.matches) {
            document.documentElement.style.removeProperty(footerRevealCssVariable);
            footerRevealHeight = 0;

            return;
        }

        const footerContentHeight = [...homeFooter.children].reduce(
            (height, section) => height + section.getBoundingClientRect().height,
            0,
        );
        const nextFooterRevealHeight = Math.max(
            minimumFooterRevealHeight,
            Math.ceil(footerContentHeight + 2),
        );

        if (nextFooterRevealHeight === footerRevealHeight) {
            return;
        }

        document.documentElement.style.setProperty(footerRevealCssVariable, `${nextFooterRevealHeight}px`);
        footerRevealHeight = nextFooterRevealHeight;
    };

    const scheduleFooterRevealHeightSync = () => {
        if (footerRevealFrame === null) {
            footerRevealFrame = window.requestAnimationFrame(syncFooterRevealHeight);
        }
    };

    if (homeFooter?.classList.contains('almc-home-footer')) {
        scheduleFooterRevealHeightSync();

        if (typeof ResizeObserver === 'function') {
            const footerResizeObserver = new ResizeObserver(scheduleFooterRevealHeightSync);

            [...homeFooter.children].forEach((section) => footerResizeObserver.observe(section));
        }

        homeFooter.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', scheduleFooterRevealHeightSync, { once: true });
        });

        if (document.fonts?.ready) {
            document.fonts.ready.then(scheduleFooterRevealHeightSync);
        }

        if (typeof footerRevealMedia.addEventListener === 'function') {
            footerRevealMedia.addEventListener('change', scheduleFooterRevealHeightSync);
        } else {
            footerRevealMedia.addListener(scheduleFooterRevealHeightSync);
        }
    }

    if (hero && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        requestAnimationFrame(() => {
            hero.classList.add('almc-home-motion-ready');
        });
    }

    const syncAccessDrawerTriggers = (isOpen) => {
        accessDrawerTriggers.forEach((trigger) => {
            trigger.setAttribute('aria-expanded', String(isOpen));
        });
    };

    const setActiveAccessTab = (tabKey, focusSelectedTab = false) => {
        const selectedTab = accessTabs.find((tab) => tab.dataset.almcAccessTabKey === tabKey);

        if (!selectedTab) {
            return false;
        }

        accessTabs.forEach((tab) => {
            const isSelected = tab === selectedTab;
            tab.setAttribute('aria-selected', String(isSelected));
            tab.tabIndex = isSelected ? 0 : -1;
        });

        accessPanels.forEach((panel) => {
            panel.hidden = panel.dataset.almcAccessPanelKey !== tabKey;
        });

        if (focusSelectedTab) {
            selectedTab.focus();
        }

        return true;
    };

    const closeAccessDrawer = () => {
        if (!accessDrawer || accessDrawer.hidden) {
            return;
        }

        accessDrawer.classList.remove('almc-home-access-drawer--open');
        accessDrawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('almc-home-access-drawer-open');
        document.body.classList.remove('almc-home-access-drawer-open');
        syncAccessDrawerTriggers(false);

        if (accessDrawerCloseTimer !== null) {
            window.clearTimeout(accessDrawerCloseTimer);
        }

        const triggerToRestore = lastAccessDrawerTrigger;

        accessDrawerCloseTimer = window.setTimeout(() => {
            if (!accessDrawer.classList.contains('almc-home-access-drawer--open')) {
                accessDrawer.hidden = true;

                if (triggerToRestore && document.contains(triggerToRestore)) {
                    triggerToRestore.focus();
                }
            }

            accessDrawerCloseTimer = null;
        }, 220);
    };

    const openAccessDrawer = (trigger) => {
        if (!accessDrawer || !accessDrawerPanel) {
            return false;
        }

        if (accessDrawerCloseTimer !== null) {
            window.clearTimeout(accessDrawerCloseTimer);
            accessDrawerCloseTimer = null;
        }

        lastAccessDrawerTrigger = trigger;
        accessDrawer.hidden = false;
        accessDrawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('almc-home-access-drawer-open');
        document.body.classList.add('almc-home-access-drawer-open');
        syncAccessDrawerTriggers(true);

        window.requestAnimationFrame(() => {
            accessDrawer.classList.add('almc-home-access-drawer--open');
            accessDrawer.querySelector('[data-almc-access-drawer-close]')?.focus();
        });

        return true;
    };

    accessDrawerTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault();

            if (accessDrawer?.hidden) {
                openAccessDrawer(trigger);
            } else {
                closeAccessDrawer();
            }
        });
    });

    accessDrawerCloseButtons.forEach((button) => {
        button.addEventListener('click', closeAccessDrawer);
    });

    accessTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            setActiveAccessTab(tab.dataset.almcAccessTabKey);
        });

        tab.addEventListener('keydown', (event) => {
            const previousIndex = index === 0 ? accessTabs.length - 1 : index - 1;
            const nextIndex = index === accessTabs.length - 1 ? 0 : index + 1;
            let targetIndex = null;

            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                targetIndex = previousIndex;
            } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                targetIndex = nextIndex;
            } else if (event.key === 'Home') {
                targetIndex = 0;
            } else if (event.key === 'End') {
                targetIndex = accessTabs.length - 1;
            }

            if (targetIndex !== null) {
                event.preventDefault();
                setActiveAccessTab(accessTabs[targetIndex].dataset.almcAccessTabKey, true);
            }
        });
    });

    const trapAccessDrawerFocus = (event) => {
        if (event.key !== 'Tab' || !accessDrawer || accessDrawer.hidden) {
            return;
        }

        const focusableElements = [...accessDrawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
            .filter((element) => !element.hidden && element.getClientRects().length > 0);

        if (!focusableElements.length) {
            event.preventDefault();
            accessDrawerPanel?.focus();

            return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    };

    const closeFooterSheet = (restoreFocus = true) => {
        if (!footerSheet || footerSheet.hidden) {
            return;
        }

        footerSheet.classList.remove('almc-home-footer-sheet--open');
        footerSheet.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('almc-home-footer-sheet-open');
        document.body.classList.remove('almc-home-footer-sheet-open');
        lastFooterSheetTrigger?.setAttribute('aria-expanded', 'false');

        if (footerSheetCloseTimer !== null) {
            window.clearTimeout(footerSheetCloseTimer);
        }

        const triggerToRestore = lastFooterSheetTrigger;

        footerSheetCloseTimer = window.setTimeout(() => {
            if (!footerSheet.classList.contains('almc-home-footer-sheet--open')) {
                footerSheet.hidden = true;
                footerSheetContent?.replaceChildren();

                if (restoreFocus && triggerToRestore && document.contains(triggerToRestore)) {
                    triggerToRestore.focus();
                }
            }

            footerSheetCloseTimer = null;
        }, 220);
    };

    const openFooterSheet = (trigger, menu) => {
        if (!footerSheet || !footerSheetPanel || !footerSheetContent || !footerSheetTitle || !menu) {
            return false;
        }

        if (footerSheetCloseTimer !== null) {
            window.clearTimeout(footerSheetCloseTimer);
            footerSheetCloseTimer = null;
        }

        const menuCopy = menu.cloneNode(true);
        const title = trigger.textContent.trim();

        menuCopy.classList.remove('dropdown-menu', 'dropdown-menu-end', 'show');
        menuCopy.classList.add('almc-home-footer-sheet-menu');
        menuCopy.removeAttribute('aria-labelledby');
        menuCopy.setAttribute('aria-label', title);

        footerSheetContent.replaceChildren(menuCopy);
        footerSheetTitle.textContent = title;
        lastFooterSheetTrigger?.setAttribute('aria-expanded', 'false');
        lastFooterSheetTrigger = trigger;
        footerSheet.hidden = false;
        footerSheet.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('almc-home-footer-sheet-open');
        document.body.classList.add('almc-home-footer-sheet-open');
        trigger.setAttribute('aria-expanded', 'true');

        window.requestAnimationFrame(() => {
            footerSheet.classList.add('almc-home-footer-sheet--open');
            footerSheet.querySelector('[data-almc-footer-sheet-close]')?.focus();
        });

        return true;
    };

    const trapFooterSheetFocus = (event) => {
        if (event.key !== 'Tab' || !footerSheet || footerSheet.hidden) {
            return;
        }

        const focusableElements = [...footerSheet.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
            .filter((element) => !element.hidden && element.getClientRects().length > 0);

        if (!focusableElements.length) {
            event.preventDefault();
            footerSheetPanel?.focus();

            return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    };

    const footerDropdowns = homeFooter?.classList.contains('almc-home-footer')
        ? [...homeFooter.querySelectorAll('.almc-home-footer-dropdown')]
        : [];

    const syncFooterDropdownLayer = () => {
        homeFooter?.classList.toggle(
            'almc-home-footer-menu-open',
            footerDropdowns.some((dropdown) => dropdown.classList.contains('show')),
        );
    };

    const closeFooterDropdowns = (except = null) => {
        footerDropdowns.forEach((dropdown) => {
            if (dropdown === except) {
                return;
            }

            const trigger = dropdown.querySelector('[data-almc-footer-dropdown-trigger]');
            const menu = dropdown.querySelector('.dropdown-menu');

            dropdown.classList.remove('show');
            trigger?.classList.remove('show');
            trigger?.setAttribute('aria-expanded', 'false');
            menu?.classList.remove('show');
        });

        syncFooterDropdownLayer();
    };

    footerDropdowns.forEach((dropdown) => {
        const trigger = dropdown.querySelector('[data-almc-footer-dropdown-trigger]');
        const menu = dropdown.querySelector('.dropdown-menu');

        if (!trigger || !menu) {
            return;
        }

        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (footerSheet && footerSheetMedia.matches) {
                if (!footerSheet.hidden && lastFooterSheetTrigger === trigger) {
                    closeFooterSheet();
                } else {
                    closeFooterDropdowns();
                    openFooterSheet(trigger, menu);
                }

                return;
            }

            closeFooterSheet(false);

            const willOpen = !menu.classList.contains('show');

            closeFooterDropdowns(willOpen ? dropdown : null);
            dropdown.classList.toggle('show', willOpen);
            trigger.classList.toggle('show', willOpen);
            trigger.setAttribute('aria-expanded', String(willOpen));
            menu.classList.toggle('show', willOpen);
            syncFooterDropdownLayer();
        });
    });

    footerSheetCloseButtons.forEach((button) => {
        button.addEventListener('click', () => closeFooterSheet());
    });

    const closeFooterSheetOnViewportChange = () => {
        if (!footerSheetMedia.matches) {
            closeFooterSheet(false);
        }
    };

    if (typeof footerSheetMedia.addEventListener === 'function') {
        footerSheetMedia.addEventListener('change', closeFooterSheetOnViewportChange);
    } else {
        footerSheetMedia.addListener(closeFooterSheetOnViewportChange);
    }

    if (footerDropdowns.length) {
        document.addEventListener('click', (event) => {
            if (!footerDropdowns.some((dropdown) => dropdown.contains(event.target))) {
                closeFooterDropdowns();
            }
        });
    }

    if (productLoadMore) {
        productLoadMore.addEventListener('click', () => {
            const hiddenProducts = [...document.querySelectorAll('[data-almc-product]')]
                .filter((product) => product.hidden);

            hiddenProducts.slice(0, 3).forEach((product) => {
                product.hidden = false;
            });

            if (hiddenProducts.length <= 3) {
                productLoadMore.hidden = true;
            }
        });
    }

    const setActiveGoal = (goalKey, focusSelectedTab = false) => {
        const selectedTab = goalTabs.find((tab) => tab.dataset.almcGoalKey === goalKey);

        if (!selectedTab) {
            return false;
        }

        goalTabs.forEach((tab) => {
            const isSelected = tab === selectedTab;
            tab.setAttribute('aria-selected', String(isSelected));
            tab.tabIndex = isSelected ? 0 : -1;
        });

        goalPanels.forEach((panel) => {
            const isSelected = panel.dataset.almcGoalKey === goalKey;

            panel.hidden = !isSelected;
            panel.classList.remove('almc-home-goal-panel-entering');

            if (isSelected && goalAutoplayMotionMedia.matches) {
                window.requestAnimationFrame(() => {
                    if (!panel.hidden) {
                        panel.classList.add('almc-home-goal-panel-entering');
                    }
                });
            }
        });

        if (focusSelectedTab) {
            selectedTab.focus();
        }

        return true;
    };

    if (goalSection && goalTabs.length && goalPanels.length) {
        const goalAutoplayDelay = 5200;
        let goalAutoplayTimer = null;
        let goalAutoplayStoppedByUser = false;
        let goalSectionIsVisible = false;

        const clearGoalAutoplay = () => {
            if (goalAutoplayTimer !== null) {
                window.clearInterval(goalAutoplayTimer);
                goalAutoplayTimer = null;
            }

            goalSection.classList.remove('almc-home-goals-autoplay');
        };

        const stopGoalAutoplay = () => {
            if (goalAutoplayStoppedByUser) {
                return;
            }

            goalAutoplayStoppedByUser = true;
            clearGoalAutoplay();
            goalSection.classList.add('almc-home-goals-user-controlled');
        };

        const cycleGoalAutoplay = () => {
            const activeIndex = goalTabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
            const nextIndex = activeIndex === -1 ? 0 : (activeIndex + 1) % goalTabs.length;

            setActiveGoal(goalTabs[nextIndex].dataset.almcGoalKey);
        };

        const startGoalAutoplay = () => {
            if (
                goalAutoplayTimer !== null
                || goalAutoplayStoppedByUser
                || !goalSectionIsVisible
                || document.hidden
                || !goalAutoplayMotionMedia.matches
            ) {
                return;
            }

            goalSection.classList.add('almc-home-goals-autoplay');
            goalAutoplayTimer = window.setInterval(cycleGoalAutoplay, goalAutoplayDelay);
        };

        goalTabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                stopGoalAutoplay();
                setActiveGoal(tab.dataset.almcGoalKey);
            });

            tab.addEventListener('keydown', (event) => {
                const previousIndex = index === 0 ? goalTabs.length - 1 : index - 1;
                const nextIndex = index === goalTabs.length - 1 ? 0 : index + 1;
                let targetIndex = null;

                if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                    targetIndex = previousIndex;
                } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                    targetIndex = nextIndex;
                } else if (event.key === 'Home') {
                    targetIndex = 0;
                } else if (event.key === 'End') {
                    targetIndex = goalTabs.length - 1;
                }

                if (targetIndex !== null) {
                    event.preventDefault();
                    stopGoalAutoplay();
                    setActiveGoal(goalTabs[targetIndex].dataset.almcGoalKey, true);
                }
            });
        });

        goalSection.addEventListener('pointerdown', stopGoalAutoplay, { once: true });
        goalSection.addEventListener('focusin', stopGoalAutoplay, { once: true });
        goalSection.addEventListener('keydown', stopGoalAutoplay, { once: true });

        const syncGoalAutoplayVisibility = (isVisible) => {
            goalSectionIsVisible = isVisible;

            if (isVisible) {
                startGoalAutoplay();
            } else {
                clearGoalAutoplay();
            }
        };

        if ('IntersectionObserver' in window) {
            const goalAutoplayObserver = new IntersectionObserver(
                ([entry]) => {
                    syncGoalAutoplayVisibility(entry.isIntersecting && entry.intersectionRatio >= .25);
                },
                { threshold: [.25] }
            );

            goalAutoplayObserver.observe(goalSection);
        } else {
            syncGoalAutoplayVisibility(true);
        }

        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                clearGoalAutoplay();
            } else {
                startGoalAutoplay();
            }
        });

        const syncGoalAutoplayMotionPreference = () => {
            if (goalAutoplayMotionMedia.matches) {
                startGoalAutoplay();
            } else {
                clearGoalAutoplay();
            }
        };

        if (typeof goalAutoplayMotionMedia.addEventListener === 'function') {
            goalAutoplayMotionMedia.addEventListener('change', syncGoalAutoplayMotionPreference);
        } else {
            goalAutoplayMotionMedia.addListener(syncGoalAutoplayMotionPreference);
        }
    }

    const resetLeadDialog = () => {
        if (!leadForm) {
            return;
        }

        leadForm.reset();
        leadForm.hidden = false;

        if (leadObjectiveInput) {
            leadObjectiveInput.value = '';
        }

        if (leadStatus) {
            leadStatus.textContent = '';
            leadStatus.removeAttribute('data-state');
        }

        if (leadIntro) {
            leadIntro.hidden = false;
        }

        if (leadSuccess) {
            leadSuccess.hidden = true;
        }

        if (leadSubmit) {
            leadSubmit.disabled = false;
        }

        if (leadSubmitLabel) {
            leadSubmitLabel.textContent = leadSubmitDefaultLabel;
        }
    };

    const closeLeadDialog = () => {
        if (leadDialog?.open) {
            leadDialog.close();
        }
    };

    const activeGoalTab = () => goalTabs.find((tab) => tab.getAttribute('aria-selected') === 'true');

    const openLeadDialog = (trigger) => {
        if (!leadDialog || !leadForm || typeof leadDialog.showModal !== 'function') {
            return false;
        }

        const selectedGoalTab = activeGoalTab();
        const goalKey = trigger.dataset.almcLeadGoal || selectedGoalTab?.dataset.almcGoalKey || '';
        const goalLabel = trigger.dataset.almcLeadGoalLabel || selectedGoalTab?.textContent.trim() || leadGoalLabel?.textContent.trim() || '';

        resetLeadDialog();

        if (leadObjectiveInput) {
            leadObjectiveInput.value = goalKey;
        }

        if (leadGoalLabel) {
            leadGoalLabel.textContent = goalLabel;
        }

        if (!leadDialog.open) {
            leadDialog.showModal();
        }

        window.requestAnimationFrame(() => {
            leadForm.elements.fullname?.focus();
        });

        return true;
    };

    document.querySelectorAll('[data-almc-lead-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            if (openLeadDialog(trigger)) {
                event.preventDefault();
            }
        });
    });

    leadDialog?.querySelectorAll('[data-almc-lead-close]').forEach((button) => {
        button.addEventListener('click', closeLeadDialog);
    });

    leadDialog?.addEventListener('click', (event) => {
        if (event.target === leadDialog) {
            closeLeadDialog();
        }
    });

    leadDialog?.addEventListener('close', resetLeadDialog);

    if (leadForm && leadSubmit) {
        leadForm.addEventListener('submit', async (event) => {
            // El modulo del antibot se engancha por `data-antibot-profile` y
            // encola el envio mientras pide el challenge, marcando el evento como
            // ya prevenido. Sin esta salida, `preventDefault()` NO detiene a los
            // demas listeners del elemento: este handler saldria igualmente sin
            // token y el relanzamiento del modulo crearia un SEGUNDO lead.
            if (event.defaultPrevented) {
                return;
            }

            event.preventDefault();

            if (!leadForm.reportValidity()) {
                return;
            }

            const formData = new FormData(leadForm);
            const originalMessage = String(formData.get('skills') || '').trim();
            const selectedGoal = leadGoalLabel?.textContent.trim() || '';
            const sanitizedPhone = String(formData.get('phone') || '').replace(/\D/g, '');
            const objectivePrefix = leadForm.dataset.objectivePrefix || '';
            const messagePrefix = leadForm.dataset.messagePrefix || '';
            const formattedMessage = `${objectivePrefix}${selectedGoal}\n\n${messagePrefix}${originalMessage}`;

            formData.set('phone', sanitizedPhone);
            formData.set('skills', formattedMessage);

            leadSubmit.disabled = true;

            if (leadSubmitLabel) {
                leadSubmitLabel.textContent = leadForm.dataset.sendingMessage || leadSubmitDefaultLabel;
            }

            if (leadStatus) {
                leadStatus.textContent = '';
                leadStatus.dataset.state = 'sending';
            }

            try {
                const response = await window.fetch(leadForm.action, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: formData,
                    credentials: 'same-origin',
                });
                const payload = await response.json().catch(() => ({}));

                if (!response.ok || payload.success !== true) {
                    const validationError = payload.errors && typeof payload.errors === 'object'
                        ? Object.values(payload.errors).flat().find((message) => typeof message === 'string')
                        : '';

                    throw new Error(validationError || leadForm.dataset.genericError || '');
                }

                leadForm.hidden = true;

                if (leadIntro) {
                    leadIntro.hidden = true;
                }

                if (leadSuccess) {
                    leadSuccess.hidden = false;
                    leadSuccess.focus();
                }
            } catch (error) {
                if (leadStatus) {
                    leadStatus.textContent = error instanceof Error && error.message
                        ? error.message
                        : leadForm.dataset.genericError || '';
                    leadStatus.removeAttribute('data-state');
                }

                leadSubmit.disabled = false;

                if (leadSubmitLabel) {
                    leadSubmitLabel.textContent = leadSubmitDefaultLabel;
                }
            }
        });
    }

    if (homeSearchForm && homeSearchInput && homeSearchSurface && homeSearchResults && homeSearchStatus && window.fetch) {
        const searchMinimumLength = 2;
        const searchDebounceDelay = 220;
        const searchHeader = document.querySelector('.body > .header')
            || document.querySelector('.header');
        const searchCloseButtons = [...homeSearchSurface.querySelectorAll('[data-almc-home-search-close]')];
        const searchSurfaceOpenClass = 'almc-home-search-surface--open';
        const searchPageOpenClass = 'almc-home-search-open';
        const searchDefaultPrompt = homeSearchIntro?.textContent.trim() || '';
        let searchAbortController = null;
        let searchDebounceTimer = null;
        let searchCloseTimer = null;
        let searchRequestId = 0;
        let ignoreNextSearchFocus = false;

        const searchSurfaceText = (key, query = '') => String(homeSearchSurface.dataset[key] || '')
            .replace(':query', query);

        const syncSearchSurfaceOffset = () => {
            const headerBottom = Math.max(0, Math.ceil(searchHeader?.getBoundingClientRect().bottom || 0));

            homeSearchSurface.style.setProperty('--almc-home-search-surface-offset', `${headerBottom}px`);
        };

        const getSearchQuery = () => homeSearchInput.value.trim();

        const syncAllResultsLink = (query) => {
            if (!homeSearchAllResults) {
                return;
            }

            if (query.length < searchMinimumLength) {
                homeSearchAllResults.hidden = true;

                return;
            }

            const resultsUrl = new URL(homeSearchForm.action, window.location.href);
            resultsUrl.searchParams.set('q', query);
            homeSearchAllResults.href = resultsUrl.toString();
            homeSearchAllResults.hidden = false;
        };

        const clearSearchResults = () => {
            homeSearchResults.replaceChildren();
        };

        const setSearchStatus = (message = '', state = '') => {
            homeSearchStatus.textContent = message;

            if (state) {
                homeSearchStatus.dataset.state = state;
            } else {
                delete homeSearchStatus.dataset.state;
            }
        };

        const setSearchIntro = (message = '') => {
            if (!homeSearchIntro) {
                return;
            }

            homeSearchIntro.textContent = message;
            homeSearchIntro.hidden = !message;
        };

        const resultIcon = (type) => {
            const normalizedType = String(type || '').toLowerCase();

            if (normalizedType.includes('blog')) {
                return 'bx-news';
            }

            if (normalizedType.includes('mcp')) {
                return 'bx-network-chart';
            }

            if (normalizedType.includes('ip')) {
                return 'bx-globe';
            }

            return 'bx-search-alt-2';
        };

        const renderSearchResults = (results) => {
            const fragment = document.createDocumentFragment();

            results.forEach((result) => {
                if (!result || typeof result !== 'object' || !result.url || !result.title) {
                    return;
                }

                let resultUrl;
                try {
                    resultUrl = new URL(String(result.url), window.location.href);
                } catch (error) {
                    return;
                }

                if (!['http:', 'https:'].includes(resultUrl.protocol)) {
                    return;
                }

                const link = document.createElement('a');
                const icon = document.createElement('i');
                const copy = document.createElement('span');
                const type = document.createElement('small');
                const title = document.createElement('strong');
                const arrow = document.createElement('i');

                link.className = 'almc-home-search-result';
                link.href = resultUrl.toString();
                link.setAttribute('role', 'listitem');

                icon.className = `bx ${resultIcon(result.type)}`;
                icon.setAttribute('aria-hidden', 'true');

                type.textContent = String(result.type || 'ALMC');
                title.textContent = String(result.title);
                copy.append(type, title);

                arrow.className = 'bx bx-right-arrow-alt';
                arrow.setAttribute('aria-hidden', 'true');

                link.append(icon, copy, arrow);
                fragment.append(link);
            });

            homeSearchResults.replaceChildren(fragment);
        };

        const openHomeSearch = () => {
            if (searchCloseTimer !== null) {
                window.clearTimeout(searchCloseTimer);
                searchCloseTimer = null;
            }

            syncSearchSurfaceOffset();
            homeSearchSurface.hidden = false;
            homeSearchSurface.setAttribute('aria-hidden', 'false');
            homeSearchInput.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add(searchPageOpenClass);
            document.body.classList.add(searchPageOpenClass);

            window.requestAnimationFrame(() => {
                homeSearchSurface.classList.add(searchSurfaceOpenClass);
            });
        };

        closeHomeSearch = (restoreFocus = true) => {
            if (homeSearchSurface.hidden) {
                return;
            }

            if (searchDebounceTimer !== null) {
                window.clearTimeout(searchDebounceTimer);
                searchDebounceTimer = null;
            }

            searchAbortController?.abort();
            searchAbortController = null;
            homeSearchSurface.classList.remove(searchSurfaceOpenClass);
            homeSearchSurface.setAttribute('aria-hidden', 'true');
            homeSearchInput.setAttribute('aria-expanded', 'false');
            document.documentElement.classList.remove(searchPageOpenClass);
            document.body.classList.remove(searchPageOpenClass);

            searchCloseTimer = window.setTimeout(() => {
                if (!homeSearchSurface.classList.contains(searchSurfaceOpenClass)) {
                    homeSearchSurface.hidden = true;
                }

                searchCloseTimer = null;
            }, 220);

            if (restoreFocus && document.contains(homeSearchInput)) {
                ignoreNextSearchFocus = true;
                homeSearchInput.focus({ preventScroll: true });
                window.setTimeout(() => {
                    ignoreNextSearchFocus = false;
                }, 0);
            }
        };

        const renderSearchPrompt = (message) => {
            clearSearchResults();
            setSearchIntro(message);
            setSearchStatus();
            syncAllResultsLink('');
        };

        const fetchSearchResults = async (query) => {
            const requestId = ++searchRequestId;
            searchAbortController?.abort();
            searchAbortController = new AbortController();
            setSearchIntro('');
            clearSearchResults();
            setSearchStatus(searchSurfaceText('almcSearchLoading'), 'loading');
            syncAllResultsLink(query);

            try {
                const endpoint = new URL(homeSearchForm.dataset.almcSearchSuggestionsUrl, window.location.href);
                endpoint.searchParams.set('q', query);

                const response = await window.fetch(endpoint.toString(), {
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    credentials: 'same-origin',
                    signal: searchAbortController.signal,
                });
                const payload = await response.json().catch(() => ({}));

                if (!response.ok) {
                    throw new Error('search-request-failed');
                }

                if (requestId !== searchRequestId || query !== getSearchQuery()) {
                    return;
                }

                const results = Array.isArray(payload.results) ? payload.results : [];

                if (results.length) {
                    renderSearchResults(results);
                    setSearchStatus(searchSurfaceText('almcSearchResultsTemplate', query), 'results');
                } else {
                    clearSearchResults();
                    setSearchStatus(searchSurfaceText('almcSearchEmptyTemplate', query), 'empty');
                }
            } catch (error) {
                if (error?.name === 'AbortError') {
                    return;
                }

                if (requestId === searchRequestId && query === getSearchQuery()) {
                    clearSearchResults();
                    setSearchStatus(searchSurfaceText('almcSearchEmptyTemplate', query), 'empty');
                }
            }
        };

        const queueSearch = () => {
            const query = getSearchQuery();

            openHomeSearch();

            if (searchDebounceTimer !== null) {
                window.clearTimeout(searchDebounceTimer);
                searchDebounceTimer = null;
            }

            searchAbortController?.abort();

            if (!query) {
                renderSearchPrompt(searchDefaultPrompt);

                return;
            }

            if (query.length < searchMinimumLength) {
                renderSearchPrompt(searchSurfaceText('almcSearchMinimum'));

                return;
            }

            searchDebounceTimer = window.setTimeout(() => {
                searchDebounceTimer = null;
                fetchSearchResults(query);
            }, searchDebounceDelay);
        };

        homeSearchInput.addEventListener('focus', () => {
            if (ignoreNextSearchFocus) {
                return;
            }

            openHomeSearch();

            if (!getSearchQuery()) {
                renderSearchPrompt(searchDefaultPrompt);
            }
        });

        homeSearchInput.addEventListener('input', queueSearch);

        homeSearchForm.addEventListener('submit', (event) => {
            event.preventDefault();
            queueSearch();
            homeSearchInput.focus({ preventScroll: true });
        });

        searchCloseButtons.forEach((button) => {
            button.addEventListener('click', () => closeHomeSearch());
        });

        window.addEventListener('resize', syncSearchSurfaceOffset, { passive: true });
        window.addEventListener('scroll', syncSearchSurfaceOffset, { passive: true });
    }

    document.addEventListener('keydown', (event) => {
        trapAccessDrawerFocus(event);
        trapFooterSheetFocus(event);

        if (event.key === 'Escape') {
            closeHomeSearch();
            closeAccessDrawer();
            closeFooterSheet();
            closeFooterDropdowns();
        }
    });
});
